"use client";

import Image from "next/image";
import Link from "next/link";

interface ImageBoxProps {
  feature: {
    heading: string;
    description: string;
    image: any;
    href: string | null;
  };
  index: number;
}

export const ImageBox = ({ feature, index }: ImageBoxProps) => {
  const hasValidHref = feature.href && feature.href.trim() !== "";

  const content = (
    <div className="bg-white flex flex-col gap-6 rounded-xl py-6 h-full group cursor-pointer overflow-hidden transition-all duration-300 hover:shadow-lg p-0  shadow-none">
      {feature.image?.url && (
        <div className="relative w-full h-full min-h-[300px] overflow-hidden -mt-6">
          <Image
            src={feature.image.url}
            alt={feature.image.alternativeText || "Image"}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
        </div>
      )}
      <div className="px-4 pb-4 h-full">
        <div>
          <h3 className="text-lg font-medium mb-2  transition-colors duration-300">
            {feature.heading}
          </h3>
          <p className="text-muted-foreground leading-relaxed">
            {feature.description}
          </p>
        </div>
      </div>
    </div>
  );

  return hasValidHref ? (
    <Link href={feature.href}>{content}</Link>
  ) : (
    <div>{content}</div>
  );
};
